import { addBasemapTile, addOverlayTile } from '../downloader'
import isNil from 'lodash/isNil'
import { waitForGoogleMaps } from '../../maploader/maploader';

let ImageMapType;

waitForGoogleMaps(() => {
  ImageMapType = class extends google.maps.MVCObject {
    constructor(props) {
      super();
      Object.assign(this, props);
    }
  };
})

function getBounds(map) {
  return new Promise(resolve => {
    let currentBounds = map.getBounds()
    let ne = currentBounds.getNorthEast()
    let sw = currentBounds.getSouthWest()
    let nwlat = ne.lat()
    let nwlng = sw.lng()
    let selat = sw.lat()
    let selng = ne.lng()
    currentBounds = {
      north: nwlat,
      south: selat,
      east: selng,
      west: nwlng
    }
    resolve(currentBounds)
  })
}

async function fetchImageUrl(token, bbox, width, height) {
  const baseUrl = `${__API_URI_3__}/Layer/Render/131`;
  const zoomLevel = 6;
  const vector = false;

  const bboxParams = `${bbox.west},${bbox.south},${bbox.east},${bbox.north}`;

  const url = `${baseUrl}?zoomLevel=${zoomLevel}&bbox=${bboxParams}&width=${width}&height=${height}&projection=3857&vector=${vector}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch image');
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
}

export async function overlayImage(layer, { mapInstance, filters, tile }, token) {
  try {
    let url
    let bbox
    let boundingBox
    if (tile) {
      boundingBox = getMapBoundingBox(mapInstance)
      const min = degrees2meters(boundingBox.west, boundingBox.south);
      const max = degrees2meters(boundingBox.east, boundingBox.north);
      bbox = `${min.xm},${min.ym},${max.xm},${max.ym}`;
    } else {
      bbox = `${boundingBox.south},${boundingBox.west},${boundingBox.north},${boundingBox.east}`;
    }
    let zoom = mapInstance.getZoom()
    if (zoom <= 5) {
      url = `${__API_URI_3__}/layer/render/${layer.id
        }?zoomLevel=${6}&bbox=${bbox}&width=${window.innerWidth}&height=${window.innerHeight}&projection=3857&units=`
    } else {
      url = `${__API_URI_3__}/layer/render/${layer.id
        }?zoomLevel=${zoom}&bbox=${bbox}&width=${window.innerWidth}&height=${window.innerHeight}&projection=3857&units=`
    }
    const fetchOptions = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    // let imageBbox = `${imageBounds.west},${imageBounds.south},${imageBounds.east},${imageBounds.north}`;
    // const url = `${__API_URI_3__}/Layer/Render/131?zoomLevel=7&bbox=-12523442.7125,3757032.813749997,-11271098.44125,5009377.084999999&width=1024&height=1024&units=`;
    // https://staging-api.basemap.com/api/V3.0/layer/render/131?zoomLevel=7&bbox=-12523442.7125,3757032.813749997,-11271098.44125,5009377.084999999&width=1024&height=1024&units=
    const response = await fetch(url, fetchOptions);
    if (!response.ok) {
      throw new Error('Failed to fetch image');
    }

    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    const overlay = new window.google.maps.GroundOverlay(
      imageUrl,
      boundingBox
    );

    overlay.setMap(mapInstance);

    setTimeout(() => {
      overlay.setMap(null);
    }, 4000)

  } catch (error) {
    console.error('Error fetching or overlaying image:', error);
  }
}

// Google Imagery & Topography
export function imageryAndTopographyGoogle(mapObj, mapInstance) {
  // this.cleanOverlayLayersFromSlider()
  // this.cleanBaseMapsFromSlider(mapObj)
  mapInstance.setOptions({
    maxZoom: 24
  })
  switch (mapObj.id) {
    case 81: // Google Imagery with Labels
      mapInstance.setMapTypeId(google.maps.MapTypeId.HYBRID)
      createMapLabels(mapInstance)
      break
    case 891: // Google Imagery with Labels
      mapInstance.setMapTypeId(google.maps.MapTypeId.HYBRID)
      createMapLabels(mapInstance)
      break
    case 82: // Google Terrain
      mapInstance.setMapTypeId(google.maps.MapTypeId.TERRAIN)
      createMapLabels(mapInstance)
      break
    default:
  }
}

// ESRI, USGS, NATGeo, Open Street Imagery & Topography
export function imageryAndTopographyOthers(mapObj, { mapInstance }) {
  let mapTypeName = mapObj.name.split(' ').join('')

  if (mapObj.maxZoomLevel) {
    mapInstance.setOptions({
      maxZoom: mapObj.maxZoomLevel - 1
    })
  } else {
    mapInstance.setOptions({
      maxZoom: 24
    })
  }

  return new Promise(resolve => {
    const imageryAndTopographyMapType = new ImageMapType({
      tileSize: new google.maps.Size(256, 256),
      getTile: function (coord, zoom, doc) {
        let normalizedCoord = getNormalizedCoord(coord, zoom)
        if (!normalizedCoord) {
          return null
        }
        let { x, y } = normalizedCoord
        const fetcher = { needsAuth: false, url: '', tile: null, zoom: zoom, name: mapTypeName, drawOrder: mapObj.drawOrder }
        if (mapObj.id >= 7000) {
          const splitPath = mapObj.serverLayerName.split('/'),
            layerPath = `${splitPath[splitPath.length - 2]}/${splitPath[splitPath.length - 1]}`
          fetcher.url = `${__API_URI__}/mapbox/render?layer=${layerPath}&zoom=${zoom}&x=${x}&y=${y}`
          fetcher.needsAuth = true
        }
        else {
          fetcher.url = `${mapObj.server}/tile/${zoom}/${y}/${x}`
        }

        fetcher.tile = doc.createElement('img')
        fetcher.tile.style.width = this.tileSize.width + 'px'
        fetcher.tile.style.height = this.tileSize.height + 'px'
        fetcher.tile.style.display = 'none'
        fetcher.tile.onerror = () => {
          fetcher.tile.style.display = 'none'
        }
        addBasemapTile(fetcher)
        return fetcher.tile
      },
      maxZoom: !isNil(mapObj.maxZoomLevel) ? mapObj.maxZoomLevel : 24,
      minZoom: 3,
      // radius: 1738000,
      name: `${mapTypeName}`,
      alt: {
        id: mapObj.id,
        order: mapObj.order,
        drawOrder: mapObj.drawOrder
      }
    })
    mapInstance.mapTypes.set(mapTypeName, imageryAndTopographyMapType)
    mapInstance.setMapTypeId(mapTypeName)
    resolve(imageryAndTopographyMapType)
  })
}

export function setOverlayIndexes(mapInstance) {
  mapInstance.overlayMapTypes.forEach((ele, idx) => {
    ele.set('overlayIndex', idx)
  })
}

export function insertOverlayMapTypes(overlay, mapInstance) {
  if (overlay) {
    let overLayTypes = [].concat(mapInstance.overlayMapTypes.getArray())
    if (overLayTypes && overLayTypes.some(rOverlay => rOverlay && rOverlay.alt.id === overlay.alt.id)) {
      return
    }
    const order = overlay.alt.drawOrder ? overlay.alt.drawOrder : overlay.drawOrder
    if (mapInstance.overlayMapTypes.getLength() === 0) {
      mapInstance.overlayMapTypes.push(overlay)
      mapInstance.overlayMapTypes.getAt(0).set('overlayIndex', 0)
    } else {
      for (let i = 0; i < overLayTypes.length; ++i) {
        const olay = overLayTypes[i],
          rOlayOrder = olay.alt.drawOrder ? olay.alt.drawOrder : olay.drawOrder
        if (rOlayOrder > order) {
          mapInstance.overlayMapTypes.insertAt(i, overlay)
          setOverlayIndexes(mapInstance)
          return
        }
      }

      const olayIndex = overLayTypes.length
      mapInstance.overlayMapTypes.push(overlay)
      setOverlayIndexes(mapInstance)
    }
  }
}

export function createMapLabels(map) {
  let onlyLabels = new google.maps.StyledMapType(
    [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'all',
        elementType: 'labels',
        stylers: [{ visibility: 'on' }]
      },
      {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ffffff', weight: 5 }]
      },
      {
        featureType: 'administrative',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#000000' }]
      },
      {
        featureType: 'landscape',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98E4A3', weight: 1 }]
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98E4A3', weight: 1 }]
      },
      {
        featureType: 'poi.attraction',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98e4dd', weight: 5 }]
      },
      {
        featureType: 'poi.medical',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ef5151', weight: 5 }]
      },
      {
        featureType: 'poi.business',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98e4dd', weight: 5 }]
      },
      {
        featureType: 'poi.government',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98E4A3', weight: 5 }]
      },
      {
        featureType: 'poi.place_of_worship',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ffffff', weight: 5 }]
      },
      {
        featureType: 'poi.school',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98e4dd', weight: 5 }]
      },
      {
        featureType: 'poi.sports_complex',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ffffff', weight: 5 }]
      },
      {
        featureType: 'landscape',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#000000', weight: 0.5 }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#000000', weight: 0.5 }]
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ffffff', weight: 5 }]
      },
      {
        featureType: 'transit',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ffffff', weight: 5 }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#ffffff', weight: 5 }]
      },
      {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#000000' }]
      },
      {
        featureType: 'transit',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#000000' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#000000' }]
      }
    ],
    {
      name: 'labels',
      alt: {
        id: 1,
        order: 20
      }
    }
  )
  insertOverlayMapTypes(onlyLabels, map)
}

export const findLayerId = (id) => {
  const ids = [
    7092, // Water Depths - Inland Waterbodies
    963, // Nationwide Trails
    908, // Nationwide USFS MVUM Roads
    917, // Nationwide Roads
    8047, // Kansas iWIHA
    418, // Kansas Walk-In Hunting Areas
    876 // Nationwide Topo Lines
    // 25 // Nationwide Government Lands
  ]
  const found = ids.find(idd => idd === id)
  if (found) {
    return true
  }

  return false
}

export const checkLayerTileSize = (id, cachedZoom, mapInstance) => {
  // // Get the bounding rectangle of the map div
  // const mapRect = mapDiv.getBoundingClientRect();
  // // Calculate the width and height of the overlay
  // const overlayWidth = mapRect.width;
  // const overlayHeight = mapRect.height;
  // Create a new Size object with the calculated width and height
  // const overlaySize = new google.maps.Size(overlayWidth, overlayHeight);
  const zoom = mapInstance.getZoom()
  if (findLayerId(id)) {
    return new google.maps.Size(256, 256)
  }
  else if (zoom < cachedZoom) {
    if (findLayerId(id)) {
      return new google.maps.Size(256, 256)
    }
    new google.maps.Size(256 * 4 * 2, 256 * 4 * 2)
  }
  // return new google.maps.Size(overlayWidth, overlayHeight)
  return new google.maps.Size(256 * 4 * 2, 256 * 4 * 2)
}

export function multiTile(mapObj, { mapInstance, filters }, tile) {
  let isCurrentFilter = false
  let units = []
  filters().map(f => {
    if (f.id == mapObj.id) {
      isCurrentFilter = true
      f.unitData.map(u => {
        units.push(u.unitId)
      })
    }
  })
  units = units.join(',')

  const overlay = new ImageMapType({
    getTile: function (coord, zoom, doc) {
      const currFilters = this.get('filters')
      let isCurrentFilter = false
      let units = []
      currFilters().map(f => {
        if (f.id == mapObj.id) {
          isCurrentFilter = true
          f.unitData.map(u => {
            units.push(u.unitId)
          })
        }
      })
      units = units.join(',')
      let { x, y } = coord
      let center = mapInstance.getCenter()
      let minLat = tileToLon(x, zoom, this.tileSize)
      let maxLat = tileToLon(x + 1, zoom, this.tileSize)
      let minLon = tileToLat(y + 1, zoom, this.tileSize)
      let maxLon = tileToLat(y, zoom, this.tileSize)

      let min = degrees2meters(minLat, minLon)
      let minX = min.xm
      let minY = min.ym

      let max = degrees2meters(maxLat, maxLon)
      let maxX = max.xm
      let maxY = max.ym

      let bboxName = mapObj.id + 'bbox'
      let projName = mapObj.id + 'proj'

      let scaleMap = [
        559082263,
        279541132,
        139770566,
        69885283,
        34942641,
        17471320,
        8735660,
        4367830,
        2183915,
        1091957,
        545978,
        272989,
        136494,
        68247,
        34123,
        17061,
        8530,
        4265,
        2132,
        1066,
        533,
        266,
        133
      ]

      // $('.map-scale').text(`Scale: 1:${scaleMap[zoom]}`)
      // $(`.${bboxName}`).text(
      //   `Bounds: [${Math.round(minX * 100) / 100}, ${Math.round(minY * 100) / 100}, ${Math.round(maxX * 100) /
      //   100}, ${Math.round(maxY * 100) / 100}]`
      // )
      // $(`.${projName}`).text('Projection: 3857')
      let url
      let bbox
      if (tile) {
        // Convert bounding box coordinates from degrees to meters
        let boundingBox = getMapBoundingBox(mapInstance)
        const min = degrees2meters(boundingBox.west, boundingBox.south);
        const max = degrees2meters(boundingBox.east, boundingBox.north);

        // Construct the bounding box string
        bbox = `${min.xm},${min.ym},${max.xm},${max.ym}`;
      } else {
        bbox = `${boundingBox.south},${boundingBox.west},${boundingBox.north},${boundingBox.east}`;
      }
      let bbbox = `${minX},${minY},${maxX},${maxY}`;
      if (zoom <= 5) {
        url = `${__API_URI_3__}/layer/render/${mapObj.id
          }?zoomLevel=${6}&bbox=${bbbox}&width=${this.tileSize.width}&height=${this.tileSize.height}&units=${units}`
        // console.log('it is called bayya')
        // url = `${__API_URI_3__}/Layer/RenderStateBoundary/AK
        //   ?zoomLevel=${6}&bbox=${bbbox}&width=${this.tileSize.width}&height=${this.tileSize.height}&units=${units}`

      } else {
        // console.log('it is called bayya')
        // console.log(units, '==================>units')
        // console.log(zoom, '=========>zoom')
        // console.log(bbbox, '=============>bbox')
        // console.log(this.tileSize.width, '=============>this.tileSize.width')
        // console.log(this.tileSize.height, '==================>this.tileSize.height')
        url = `${__API_URI_3__}/layer/render/${mapObj.id
          }?zoomLevel=${zoom}&bbox=${bbbox}&width=${this.tileSize.width}&height=${this.tileSize.height}&units=${units}`
        // url = `${__API_URI_3__}/Layer/RenderStateBoundary/co?zoomLevel=${zoom}&bbox=${bbbox}&width=${this.tileSize.width}&height=${this.tileSize.height}&units=${units}`

      }
      const fetcher = { needsAuth: true, url: url, tile: null, zoom: zoom, id: mapObj.id, drawOrder: mapObj.drawOrder }

      fetcher.tile = doc.createElement('img')
      // fetcher.tile.style.display = 'none'
      // fetcher.tile.style.border = '1px solid red'
      fetcher.tile.onerror = () => {
        fetcher.tile.style.display = 'none'
      }
      fetcher.tile.onload = (e) => {
        fetcher.tile.style.display = 'block'
      }

      fetcher.tile.style.left = '0px'
      fetcher.tile.style.top = '0px'
      addOverlayTile(fetcher)
      return fetcher.tile
    },
    tileSize: checkLayerTileSize(mapObj.id, mapObj.cachedZoomLevel, mapInstance),
    minZoom: 3,
    name: mapObj.name,
    opacity: 1,
    visible: true,  // Adjust as needed
    maxZoom: 18,
    alt: {
      id: mapObj.id,
      order: mapObj.order,
      drawOrder: mapObj.drawOrder
    }
  })
  overlay.set('filters', filters)
  return overlay
}




export function singleTile(mapObj, { mapInstance, ruggedMapMode, filters }) {
  return new Promise(resolve => {
    let isCurrentFilter = false
    let units = []
    filters().map(f => {
      if (f.layerId == mapObj.id) {
        isCurrentFilter = true
        f.filterFields.unitData.map(u => {
          units.push(u.unitId)
        })
      }
    })
    units = units.join(',')

    let zoom = mapInstance.getZoom()
    getBounds(mapInstance).then(bounds => {
      let bboxName = mapObj.id + 'bbox'
      let projName = mapObj.id + 'proj'

      let scaleMap = [
        559082263,
        279541132,
        139770566,
        69885283,
        34942641,
        17471320,
        8735660,
        4367830,
        2183915,
        1091957,
        545978,
        272989,
        136494,
        68247,
        34123,
        17061,
        8530,
        4265,
        2132,
        1066,
        533,
        266,
        133
      ]

      $('.map-scale').text(`Scale: 1:${scaleMap[zoom]}`)

      $(`.${bboxName}`).text(
        `Bounds: [${Math.round(bounds.west * 100) / 100}, ${Math.round(bounds.south * 100) / 100},\n ${Math.round(
          bounds.east * 100
        ) / 100}, ${Math.round(bounds.north * 100) / 100}]`
      )
      $(`.${projName}`).text('Projection: 4326')


      let groundOverlay = null
      if (mapObj.id !== 898 && mapObj.id !== 912) {
        groundOverlay = new google.maps.GroundOverlay('', bounds, {
          clickable: true
        })
        groundOverlay.set('shouldRender', true)
        groundOverlay.set('renderedZoom', zoom)
        groundOverlay.set('fetcher', () => {
          getBounds(mapInstance).then(newBounds => {
            let url = ''
            zoom = mapInstance.getZoom()
            if (!isCurrentFilter || !units) {
              url = `${__API_URI_3__}/layer/render/${mapObj.id}?zoomLevel=${zoom}&bbox=${newBounds.west
                },${newBounds.south},${newBounds.east},${newBounds.north}&width=${$(window).width() - 50}&height=${$(
                  window
                ).height()}&projection=4326`
            } else if (isCurrentFilter) {
              url = `${__API_URI_3__}/layer/render/${mapObj.id}?zoomLevel=${zoom}&bbox=${newBounds.west
                },${newBounds.south},${newBounds.east},${newBounds.north}&width=${$(window).width() - 50}&height=${$(
                  window
                ).height()}&projection=4326&units=${units}`
            }
            // groundOverlay.set('renderedZoom', zoom)
            const fetcher = { needsAuth: false, url: url, tile: tile, zoom: zoom, id: mapObj.id }
            addOverlayTile(fetcher)
          })
        })

        let tile = document.getElementById(`${mapObj.id}_cache`)
        if (isNil(tile)) {
          tile = document.createElement('img')
          tile.id = `${mapObj.id}_cache`
          tile.style.display = 'none'
          document.body.appendChild(tile)
        }

        tile.onerror = (e) => {
          tile.style.display = 'none'
        }
        tile.onload = () => {
          if (groundOverlay.get('shouldRender')) {
            tile.style.display = 'none'
            groundOverlay.url = tile.src
            groundOverlay.set('renderedZoom', mapInstance.getZoom())
            groundOverlay.setMap(mapInstance)
          }
        }

        groundOverlay.set('tile', tile)
        groundOverlay.get('fetcher')()
      } else {
        // https://developers.google.com/maps/documentation/javascript/examples/overlay-simple
        class customOverlay extends google.maps.OverlayView {
          constructor(bounds, map) {
            super()
            this._bounds = bounds
            this._map = map
            this.overlayImage = null

            this._div = null
          }
        }
        customOverlay.prototype.onAdd = function () {
          const div = document.createElement('div')
          div.style.borderStyle = 'none'
          div.style.borderWidth = '0px'
          div.style.position = 'absolute'

          const img = document.createElement('img')
          img.src = ''
          img.style.width = '100%'
          img.style.height = '100%'
          img.style.position = 'absolute'
          img.style.display = 'none'
          div.appendChild(img)
          this.overlayImage = img

          this._div = div

          const panes = this.getPanes()
          panes.overlayLayer.appendChild(div)
        }

        customOverlay.prototype.draw = function () {
          this._div.style.left = '0px'
          this._div.style.top = '0px'
          this._div.style.width = window.innerWidth - 50 + 'px'
          this._div.style.height = window.innerHeight + 'px'
          this._div.style.transform = `translate(${-(window.innerWidth / 2) + 25}px, -${window.innerHeight / 2}px)`

          getBounds(mapInstance).then(newBounds => {
            const BL = degrees2meters(newBounds.west, newBounds.south),
              TR = degrees2meters(newBounds.east, newBounds.north),
              boundingRect = mapInstance.getDiv().getBoundingClientRect()

            const fetcher = { needsAuth: false, tile: this.overlayImage, url: '', zoom: zoom, id: mapObj.id }
            zoom = mapInstance.getZoom()
            // BL.xm === west, BL.ym === south, TR.xm === east, TR.ym === north
            fetcher.url = `${__API_URI_3__}/layer/render/${mapObj.id}?zoomLevel=${zoom}&bbox=${BL.xm},${BL.ym},${TR.xm},${TR.ym}&width=${Math.floor(boundingRect.width)}&height=${Math.floor(boundingRect.height)}`
            fetcher.tile.style.display = 'none'
            fetcher.tile.onerror = (e) => {
              fetcher.tile.style.display = 'none'
            }
            fetcher.tile.onload = (e) => {
              fetcher.tile.style.display = 'block'
            }
            addOverlayTile(fetcher)
          })
        }

        customOverlay.prototype.onRemove = function () {
          this._div.parentNode.removeChild(this._div)
          this._div = null
        }
        groundOverlay = new customOverlay(bounds, mapInstance)

      }
      groundOverlay.alt = {
        id: mapObj.id,
        order: mapObj.order,
        drawOrder: mapObj.drawOrder
      }
      groundOverlay.name = mapObj.name
      // google.maps.event.addListener(groundOverlay, 'dblclick', () => {
      //   this.setState({ doubleClicked: true }, () => {
      //     setTimeout(() => this.setState({ doubleClicked: false }), 300)
      //   })
      // })

      resolve(groundOverlay)
    })
  })
}

export function getWorldCoords(latLng) {
  let TILE_SIZE = 256
  let siny = Math.sin((latLng.lat() * Math.PI) / 180)

  siny = Math.min(Math.max(siny, -0.9999), 0.9999)

  return new google.maps.Point(
    TILE_SIZE * (0.5 + latLng.lng() / 360),
    TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI))
  )
}

export function tileToLat(coord, zoom, tileSize) {
  //height
  const scale = 256 / tileSize.height
  let n = Math.PI - (2.0 * Math.PI * coord) / (scale * Math.pow(2.0, zoom))
  const lat = Math.atan(Math.sinh(n)) * (180 / Math.PI)
  return lat
}

export function tileToLon(coord, zoom, tileSize) {
  const scale = tileSize.width / 256

  const lon = (scale * coord / Math.pow(2.0, zoom)) * 360.0 - 180
  return lon
}

export function degrees2meters(lon, lat) {
  let xm = (lon * 20037508.34) / 180
  let ym = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180)
  ym = (ym * 20037508.34) / 180

  return { xm, ym }
}

function getMapBoundingBox(map) {
  const bounds = map.getBounds();
  const northEast = bounds.getNorthEast();
  const southWest = bounds.getSouthWest();
  if (bounds) {
    const boundingBox = {
      north: northEast.lat(),
      east: northEast.lng(),
      south: southWest.lat(),
      west: southWest.lng(),
    };
    return boundingBox
  }
}

export function getNormalizedCoord(coord, zoom) {
  let y = coord.y
  let x = coord.x

  let tileRange = 1 << zoom

  if (y < 0 || y >= tileRange) {
    return null
  }

  if (x < 0 || x >= tileRange) {
    x = ((x % tileRange) + tileRange) % tileRange
  }

  return { x: x, y: y }
}

export function multiTileLayersXYZ({ mapInstance, filters }, mapObj) {
  let overlay;
  let zoomEvent;
  function createOverlay() {
    if (!mapInstance) {
      console.error("Error: mapInstance is undefined.");
      return;
    }

    // ✅ OpenStreetMap Tile URL

    let xyzTileUrl;

    // if (mapObj.cloudfrontUrl) {
    //   xyzTileUrl = mapObj.cloudfrontUrl;
    // }
    // else {
    //   // xyzTileUrl = 'https://d17nskp3ikx9h0.cloudfront.net/tiles/USA:usa_govtlandparcels_vpaid/EPSG:3857/png8/default/{z}/{x}/{y}.png'
    // }

    if (mapObj.cloudfrontUrl) {

      if (__NODE_ENV__ == 'production') {
        if (typeof mapObj.cloudfrontUrl === 'string' && mapObj.cloudfrontUrl.includes("app.basemap.com")) {
          xyzTileUrl = mapObj.cloudfrontUrl.replace("app.basemap.com/layers.basemap.com", "layers.basemap.com");
        }
        else {
          xyzTileUrl = mapObj.cloudfrontUrl;
        }
      } else {
        if (typeof mapObj.cloudfrontUrl === 'string' && mapObj.cloudfrontUrl.includes("staging.basemap.com")) {
          xyzTileUrl = mapObj.cloudfrontUrl.replace("staging.basemap.com/staging-layers.basemap.com", "staging-layers.basemap.com");
        }
        else {
          xyzTileUrl = mapObj.cloudfrontUrl;
        }
      }
    }


    // xyzTileUrl = 'https://d17nskp3ikx9h0.cloudfront.net/tiles/DEMS:lidar_hillshade/EPSG:3857/png/default/{z}/{x}/{y}.png'
    // xyzTileUrl = "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
    // xyzTileUrl = "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}"
    // xyzTileUrl = "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}"
    // xyzTileUrl = "https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"

    // ✅ Function to get tile bounds
    function getTileBounds(x, y, zoom) {
      const n = Math.pow(2, zoom);
      const lon_w = (x / n) * 360 - 180;
      const lon_e = ((x + 1) / n) * 360 - 180;
      const lat_n_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * y / n)));
      const lat_s_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * (y + 1) / n)));
      const lat_n = lat_n_rad * 180 / Math.PI;
      const lat_s = lat_s_rad * 180 / Math.PI;

      return {
        north: lat_n,
        south: lat_s,
        east: lon_e,
        west: lon_w
      };
    }

    // ✅ Create an XYZ Tile Layer
    overlay = new google.maps.ImageMapType({

      getTileUrl: function (coord, zoom) {
        const tileBounds = getTileBounds(coord.x, coord.y, zoom);
        let tmsY
        // true conversion  &  false means direct
        if (true) {
          tmsY = (1 << zoom) - 1 - coord.y;
        } else {
          tmsY = coord.y;
        }
        return xyzTileUrl
          .replace("{x}", coord.x)
          .replace("{y}", tmsY)
          .replace("{z}", zoom);
      },
      minZoom: 3,
      name: mapObj.name,
      opacity: 1,
      visible: true,  // Adjust as needed
      maxZoom: 18,
      alt: {
        id: mapObj?.id,
        order: mapObj?.order,
        drawOrder: mapObj?.drawOrder
      }
    });
  }

  createOverlay();
  overlay.set('filters', filters)

  return overlay;
}

export function multiTileHuntLayers(mapObjVal, { mapInstance, filters }, tile) {

  let isCurrentFilter = false
  let units = []

  units = units.join(',')


  const overlay = new ImageMapType({
    getTile: function (coord, zoom, doc) {

      let units = []

      units = units.join(',')
      let { x, y } = coord
      let center = mapInstance.getCenter()
      let minLat = tileToLon(x, zoom, this.tileSize)
      let maxLat = tileToLon(x + 1, zoom, this.tileSize)
      let minLon = tileToLat(y + 1, zoom, this.tileSize)
      let maxLon = tileToLat(y, zoom, this.tileSize)

      let min = degrees2meters(minLat, minLon)
      let minX = min.xm
      let minY = min.ym

      let max = degrees2meters(maxLat, maxLon)
      let maxX = max.xm
      let maxY = max.ym

      let scaleMap = [
        559082263,
        279541132,
        139770566,
        69885283,
        34942641,
        17471320,
        8735660,
        4367830,
        2183915,
        1091957,
        545978,
        272989,
        136494,
        68247,
        34123,
        17061,
        8530,
        4265,
        2132,
        1066,
        533,
        266,
        133
      ]

      let url
      let bbox
      if (tile) {
        // Convert bounding box coordinates from degrees to meters
        let boundingBox = getMapBoundingBox(mapInstance)
        const min = degrees2meters(boundingBox.west, boundingBox.south);
        const max = degrees2meters(boundingBox.east, boundingBox.north);

        // Construct the bounding box string
        bbox = `${min.xm},${min.ym},${max.xm},${max.ym}`;
      } else {
        bbox = `${boundingBox.south},${boundingBox.west},${boundingBox.north},${boundingBox.east}`;
      }
      let bbbox = `${minX},${minY},${maxX},${maxY}`;
      if (zoom <= 5) {
        // console.log('it is called bayya')
        url = `${__API_URI_3__}/Layer/RenderStateBoundary/AK
          ?zoomLevel=${6}&bbox=${bbbox}&width=${this.tileSize.width}&height=${this.tileSize.height}&units=${units}`

      } else {
        // console.log('it is called bayya')
        // console.log(units, '==================>units')
        // console.log(zoom, '=========>zoom')
        // console.log(bbbox, '=============>bbox')
        // console.log(this.tileSize.width, '=============>this.tileSize.width')
        // console.log(this.tileSize.height, '==================>this.tileSize.height')
        url = `${__API_URI_3__}/Layer/RenderStateBoundary/${mapObjVal}?zoomLevel=${zoom}&bbox=${bbbox}&width=${this.tileSize.width}&height=${this.tileSize.height}&units=${units}`

      }
      const fetcher = { needsAuth: true, url: url, tile: null, zoom: zoom, id: '', drawOrder: '' }

      fetcher.tile = doc.createElement('img')
      // fetcher.tile.style.display = 'none'
      // fetcher.tile.style.border = '1px solid red'
      fetcher.tile.onerror = () => {
        fetcher.tile.style.display = 'none'
      }
      fetcher.tile.onload = (e) => {
        fetcher.tile.style.display = 'block'
      }

      fetcher.tile.style.left = '0px'
      fetcher.tile.style.top = '0px'
      addOverlayTile(fetcher)
      return fetcher.tile
    },
    // tileSize: checkLayerTileSize(mapObj.id, mapObj.cachedZoomLevel, mapInstance),
    tileSize: new google.maps.Size(256 * 4 * 2, 256 * 4 * 2),
    minZoom: 3,
    // name: mapObj.name,
    opacity: 1,
    visible: true,  // Adjust as needed
    maxZoom: 18,
    // alt: {
    //   id: mapObj.id,
    //   order: mapObj.order,
    //   drawOrder: mapObj.drawOrder
    // }
  })
  // overlay.set('filters', filters)


  mapInstance.overlayMapTypes.insertAt(0, overlay);
  console.log("Overlay added to map:", mapInstance.overlayMapTypes);

  return overlay;


  // return overlay
}